/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Course Assignment Progress Service
 * This service is used to get list of assignments by courseId
 * @file CourseAssignmentProgressService.js
 * @author Gladson Samuel S
 */

import Framework, { BaseService } from '@greenville/framework';
import { AET_STORE_EVENTS } from '../common/Constants';

export default class CourseAssignmentProgressService extends BaseService {
  constructor() {
    super(AET_STORE_EVENTS.COURSE_ASSIGNMENT_PROGRESS_REQUESTED, 'courseAssignmentProgressStatus');
  }

  /**
   * API call for Course Assignment Progress
   * @param {*} eventName
   * @param {*} eventData
   * @returns {Promise}
   */
  handleEvent(eventName, eventData = {}) {
    const { courseId, assignmentId } = eventData;
    const assignmentFilter = assignmentId ? `?assignmentId=${assignmentId}` : '';

    return this.getClient('marinV2').get(`/aet/courses/${courseId}/assignments/progress${assignmentFilter}`);
  }

  // eslint-disable-next-line class-methods-use-this
  handleResponse(response) {
    const data = response?.data || [];

    Framework.getStoreRegistry().getStore('assignment').setAllAssignmentsProgress(data);
    Framework.getEventManager().publish(AET_STORE_EVENTS.COURSE_ASSIGNMENT_PROGRESS_COMPLETED, data);
  }

  // eslint-disable-next-line class-methods-use-this
  handleError(error) {
    Framework.getEventManager().publish(AET_STORE_EVENTS.COURSE_ASSIGNMENT_PROGRESS_FAILED, error);
  }
}
